module.exports = __webpack_public_path__ + "img/7.8f76cdea.jpg";